import React from 'react'
import ContactSection from "../sections/Home/ContactSection";
import MainLayout from '../components/MainLayout';

const ContactPage = () => {
    return (
        <MainLayout>
            <div>
                <ContactSection />
            </div>
        </MainLayout>
    )
}

export default ContactPage